import React, { useLayoutEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import {
  getMaintenanceWarnings,
  clearMaintenanceWarnings,
} from '../../../../actions/index';
import { optionsPropTypes } from './SelectPropTypes';
import Select from './Select';
import { maintenanceWarningsGenerator } from '../../../../utils/app/json-generator-from-reducer';

export const MaintenanceWarningSelect = ({
  loading,
  options,
  isGridVariant,
  isMulti,
  isClearable,
  onValueChange,
  dispatchClearMaintenanceWarnings,
  dispatchGetMaintenanceWarnings,
  registeredBusId,
  searchByCompanyResource,
  ...rest
}) => {
  useLayoutEffect(() => () => dispatchClearMaintenanceWarnings(true), []);

  const onInputChangeMaintenanceWarning = (inputValue) => {
    if (!inputValue.trim().length) {
      return;
    }
    const query = searchByCompanyResource
      ? [
          `id:${inputValue}`,
          `serviceOrderId:Ø`,
          `companyResourceId:${registeredBusId}`,
        ]
      : [
          `id:${inputValue}`,
          `serviceOrderId:Ø`,
          `registeredBusId:${registeredBusId}`,
        ];

    dispatchGetMaintenanceWarnings({ query }, true);
  };

  return (
    <Select
      isLoading={loading}
      onInputChange={onInputChangeMaintenanceWarning}
      options={options}
      isMulti={isMulti}
      onValueChange={onValueChange}
      isClearable={isClearable}
      isGridVariant={isGridVariant}
      {...rest}
    />
  );
};

MaintenanceWarningSelect.propTypes = {
  isGridVariant: PropTypes.bool,
  dispatchGetMaintenanceWarnings: PropTypes.func.isRequired,
  dispatchClearMaintenanceWarnings: PropTypes.func.isRequired,
  onValueChange: PropTypes.func,
  loading: PropTypes.bool.isRequired,
  isMulti: PropTypes.bool,
  options: optionsPropTypes,
  isClearable: PropTypes.bool,
  placeholder: PropTypes.string,
  registeredBusId: PropTypes.number.isRequired,
  searchByCompanyResource: PropTypes.bool,
  useSearch: PropTypes.bool,
  onlyCorrective: PropTypes.bool,
  onlyPreventive: PropTypes.bool,
};

MaintenanceWarningSelect.defaultProps = {
  isGridVariant: false,
  isMulti: false,
  options: [],
  isClearable: false,
  onValueChange: undefined,
  placeholder: 'Busca por ID de alerta',
  searchByCompanyResource: false,
  useSearch: false,
  onlyCorrective: false,
  onlyPreventive: false,
};

const mapStateToProps = ({ MechanicalMaintenanceUnit }, ownProps) => {
  const key = ownProps.useSearch ? 'all' : 'allInSelect';

  const raw = MechanicalMaintenanceUnit.MaintenanceWarning.getIn([
    key,
    'content',
    'content',
  ]);

  const hasCorrectiveFields = (w) => {
    const maintenanceFailModeId =
      w && w.get ? w.maintenanceFailModeId : w.maintenanceFailModeId;

    const activityCompanyResourceId =
      w && w.get ? w.activityCompanyResourceId : w.activityCompanyResourceId;

    return Boolean(maintenanceFailModeId || activityCompanyResourceId);
  };

  let filtered = raw;

  if (ownProps.onlyCorrective === true) {
    filtered = raw.filter((w) => hasCorrectiveFields(w));
  } else if (ownProps.onlyPreventive === true) {
    filtered = raw.filter((w) => !hasCorrectiveFields(w));
  }

  return {
    options: maintenanceWarningsGenerator(filtered),
    loading: MechanicalMaintenanceUnit.MaintenanceWarning.getIn([
      key,
      'loading',
    ]),
  };
};

const mapDispatchToProps = {
  dispatchGetMaintenanceWarnings: getMaintenanceWarnings,
  dispatchClearMaintenanceWarnings: clearMaintenanceWarnings,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(MaintenanceWarningSelect);
